"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryModellerBase = void 0;
const data_1 = require("@grafana/data");
const types_1 = require("./types");
class QueryModellerBase {
    constructor(operationDefinitions, innerQueryPlaceholder) {
        this.categories = [];
        this.operationsRegistry = new data_1.Registry(() => operationDefinitions);
        this.innerQueryPlaceholder = innerQueryPlaceholder || '<query>';
    }
    setOperationCategories(categories) {
        this.categories = categories;
    }
    getOperationsForCategory(category) {
        return this.operationsRegistry.list().filter((op) => op.category === category && !op.hideFromList);
    }
    getAlternativeOperations(key) {
        return this.operationsRegistry.list().filter((op) => op.alternativesKey && op.alternativesKey === key);
    }
    getCategories() {
        return this.categories;
    }
    getOperationDefinition(id) {
        return this.operationsRegistry.getIfExists(id);
    }
    hasBinaryOp(query) {
        return (query.operations.find((op) => {
            const def = this.getOperationDefinition(op.id);
            return (def === null || def === void 0 ? void 0 : def.category) === types_1.BINARY_OPERATIONS_KEY;
        }) !== undefined);
    }
}
exports.QueryModellerBase = QueryModellerBase;
//# sourceMappingURL=QueryModellerBase.js.map